import { useState } from 'react';
import { analyzeSentiment } from '../../../../services/api';

const SENTIMENT_LABELS = {
  positive: 'Positivo',
  negative: 'Negativo',
  neutral: 'Neutro'
};

const useArticleModalSentimentActions = ({
  isSentimentAIEnabled,
  localArticle,
  onUpdateSentiment,
  setLocalArticle,
  showSnackbar
}) => {
  const [sentimentAnalyzing, setSentimentAnalyzing] = useState(false);

  const handleUpdateSentiment = async (articleId, sentiment) => {
    const previousSentiment = localArticle.sentiment;
    try {
      setLocalArticle(prev => ({
        ...prev,
        sentiment
      }));

      if (onUpdateSentiment) {
        await onUpdateSentiment(articleId, sentiment);
      }
    } catch (error) {
      setLocalArticle(prev => ({
        ...prev,
        sentiment: previousSentiment
      }));
      console.error('Erro ao atualizar sentimento:', error);
    }
  };

  const handleAnalyzeSentiment = async () => {
    if (sentimentAnalyzing) return;
    if (!isSentimentAIEnabled()) {
      showSnackbar('Ative sua MIA (Mensure IA) para usar a análise de sentimento.');
      return;
    }

    setSentimentAnalyzing(true);
    try {
      const response = await analyzeSentiment(localArticle._id);
      const { sentiment } = response.data;
      setLocalArticle(prev => ({ ...prev, sentiment }));
      if (onUpdateSentiment) onUpdateSentiment(localArticle._id, sentiment);
      showSnackbar(`Sentimento detectado: ${SENTIMENT_LABELS[sentiment] || sentiment}`);
    } catch (error) {
      console.error('Erro ao analisar sentimento:', error);
      showSnackbar(error.response?.data?.message || 'Erro ao analisar sentimento.');
    } finally {
      setSentimentAnalyzing(false);
    }
  };

  return {
    handleAnalyzeSentiment,
    handleUpdateSentiment,
    sentimentAnalyzing
  };
};

export default useArticleModalSentimentActions;
